import { styled } from 'styled-components'

export const PageWrapper = styled.div`
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 20px;
`

export const ContentContainer = styled.div`
  width: 100%;
  max-width: 500px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const Card = styled.div`
  background: ${(props) => props.theme.background.white};
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  overflow: hidden;
  animation: fadeIn 0.5s ease;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`

export const CardHeader = styled.div`
  padding: 24px;
  border-bottom: 1px solid #f0f0f0;

  h2 {
    font-size: 20px;
    font-weight: 600;
    color: ${(props) => props.theme.text.dark};
    text-align: center;
    margin: 0;
  }
`

export const FormContainer = styled.div`
  padding: 24px;
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  label {
    font-size: 14px;
    font-weight: 500;
    color: ${(props) => props.theme.text.dark};
  }
`

export const Input = styled.input`
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 16px;
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: ${(props) => props.theme.button.light};
    box-shadow: 0 0 0 2px rgba(53, 126, 221, 0.2);
  }

  &::placeholder {
    color: #aaa;
  }
`

export const SubmitButton = styled.button`
  width: 100%;
  padding: 14px 20px;
  background-color: ${(props) => props.theme.button.light};
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 8px;

  &:hover {
    background-color: ${(props) => props.theme.button.hoverBlue};
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`

export const ErrorMessage = styled.p`
  margin: 4px 0 0 0;
  color: #e53935;
  font-size: 13px;
  animation: shake 0.5s ease;

  @keyframes shake {
    0%,
    100% {
      transform: translateX(0);
    }
    20%,
    60% {
      transform: translateX(-5px);
    }
    40%,
    80% {
      transform: translateX(5px);
    }
  }
`

export const StatusMessage = styled.div<{ isError?: boolean }>`
  padding: 12px 16px;
  background-color: ${(props) =>
    props.isError ? 'rgba(229, 57, 53, 0.1)' : 'rgba(76, 175, 80, 0.1)'};
  color: ${(props) => (props.isError ? '#e53935' : '#4caf50')};
  border-radius: 8px;
  font-size: 14px;
  margin-top: 16px;
  text-align: center;
`

export const LanguageSwitcherContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;

  h3 {
    font-size: 16px;
    font-weight: 500;
    color: ${(props) => props.theme.text.dark};
    margin: 0;
  }
`

export const LanguageButtonGroup = styled.div`
  display: flex;
  gap: 8px;
`

export const LanguageButton = styled.button<{ isActive?: boolean }>`
  padding: 8px 16px;
  background-color: ${(props) => (props.isActive ? props.theme.button.light : 'transparent')};
  color: ${(props) => (props.isActive ? 'white' : props.theme.text.dark)};
  border: 1px solid ${(props) => (props.isActive ? props.theme.button.light : '#e0e0e0')};
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${(props) => (props.isActive ? props.theme.button.hoverBlue : '#f5f5f5')};
  }
`
